module.exports = __webpack_public_path__ + "img/shop_stand.fc6196de.jpg";